import React from 'react';
import CustomButton from '../../../components/CustomButtons/ButtonTS';
import CancelIcon from '@material-ui/icons/Cancel';
import SettingsBackupRestore from '@material-ui/icons/SettingsBackupRestore';
import SweetAlert from 'react-bootstrap-sweetalert';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody.js';
import CardHeader from '../../../components/Card/CardHeader.js';
import CardIcon from '../../../components/Card/CardIcon.js';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { closeSweetAlertStyle, sweetAlertStyle } from '../../helpers/CustomStyles';
import utils from '../../helpers/GlobalVariables';
import Loading from '../Loading/Loading';

interface IResetSensorErrorCountsConfirmationProps {
    title?: string;
    message: React.ReactNode;
    resetting: boolean;
    onCancel: () => void;
    onReset: () => void;
}

const closeButtonStyle = {
    border: '1px solid #00acc1',
};

// confirmation of a sensor error counters reset (installer panel - all systems, Devices page - a single device)
const ResetSensorErrorCountsConfirmation = ({ title = 'Sensor error counters', message, resetting, onCancel, onReset }: IResetSensorErrorCountsConfirmationProps) => {
    const hide = () => {
        if (!resetting) onCancel();
    };

    return (
        <SweetAlert
            title=''
            showConfirm={false}
            style={sweetAlertStyle}
            onConfirm={hide}
            onCancel={hide}
            key='reset-sensor-error-counts-confirmation-alert'
        >
            <GridContainer>
                <GridItem xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <CustomButton simple justIcon color='info' style={closeSweetAlertStyle} onClick={hide}>
                        <CancelIcon style={{ width: '20px', height: '20px' }} />
                    </CustomButton>
                </GridItem>
            </GridContainer>
            <Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} className='node-edit-card'>
                <CardHeader color='info' icon>
                    <CardIcon color='info'>
                        <SettingsBackupRestore />
                    </CardIcon>
                    <h3 style={utils.sweetAlertHeaderStyle}>{title}</h3>
                </CardHeader>
                <CardBody>
                    <GridContainer>
                        <GridItem xs={12}>
                            <h5>{message}</h5>
                        </GridItem>
                        <GridItem xs={12} style={{ margin: '15px 0 0 0 ' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
                                <CustomButton simple color='info' style={closeButtonStyle} onClick={hide} disabled={resetting}>
                                    cancel
                                </CustomButton>
                                <CustomButton style={{ backgroundColor: resetting ? '#ccc' : '#f44336' }} onClick={onReset} disabled={resetting}>
                                    {resetting ? <Loading transform={1} height={17} width={48} color='darkGray' /> : 'reset'}
                                </CustomButton>
                            </div>
                        </GridItem>
                    </GridContainer>
                </CardBody>
            </Card>
        </SweetAlert>
    );
};

export default ResetSensorErrorCountsConfirmation;
